module.exports = __webpack_public_path__ + "7976a62732ec1eb3f4ad937a77a1e8fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/lightbulb-blue.png
// module id = 618
// module chunks = 0